module.exports = __webpack_public_path__ + "img/courseImg2.f4f8700f.png";